var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildOgImagePreviewUrl } from '../utils/build-og-image-preview';
export var getBasicVideosObject = function (videos, _a) {
    if (videos === void 0) { videos = []; }
    var _b = _a === void 0 ? {} : _a, includeContext = _b.includeContext, _c = _b.positioning, positioning = _c === void 0 ? false : _c;
    var videoObjects = videos.map(function (_a, index) {
        var thumbnailUrl = _a.thumbnailUrl, name = _a.name, description = _a.description, uploadDate = _a.uploadDate, duration = _a.duration, contentUrl = _a.contentUrl, embedUrl = _a.embedUrl, expires = _a.expires;
        return (__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (positioning && { position: index + 1 })), (includeContext ? { '@context': 'https://schema.org/' } : {})), { '@type': 'VideoObject' }), (thumbnailUrl && {
            thumbnailUrl: buildOgImagePreviewUrl({ url: thumbnailUrl }),
        })), (name && { name: name })), (description && { description: description })), (uploadDate && { uploadDate: uploadDate })), (duration && { duration: duration })), (contentUrl && { contentUrl: contentUrl })), (embedUrl && { embedUrl: embedUrl })), (expires && { expires: expires })));
    });
    return videoObjects.length
        ? {
            videos: videoObjects,
        }
        : {};
};
